import React from 'react'
import { Helmet } from 'react-helmet'

import { unescape } from 'helpers/text'
import { OriginByLocaleMapType } from 'store/urlManager.store'
import { HrefLangType, LocaleType } from 'types/locale'
import connect from './connect'
import { generateMeta, prepareLinks } from './helpers'

export interface IDocumentHead {
  defaultTitle: string
  defaultDescription: string
  title: string
  description: string
  locale: string
  currentPath: string
  currentUrl: string
  viewport: string
  robots: string
  canonicalUrl: string
  mobileUrl: string

  links?: any[]
  customMeta?: any[]
  mobileQueryObj?: any

  isNotFoundPage: boolean
  shouldAppendSearchBoxJSONLD: boolean
  shouldAppendOrganizationJSONLD: boolean
  renderHreflangs: boolean
  renderCanonical: boolean
  allowEmptyHreflangs: boolean
  customTitleTemplate: boolean
  renderMobileAlternate: boolean
  originByLocaleMap: OriginByLocaleMapType
  mobileOriginByLocaleMap: OriginByLocaleMapType
  excludeLocales: LocaleType[]
  isCzech: boolean
  hrefLangsRelatedToLocale: HrefLangType[]
  hasDroppedSubDomain: boolean
}

function DocumentHead({
  defaultTitle = '',
  defaultDescription = '',
  title = '',
  description = '',
  locale = '',
  currentPath = '',
  currentUrl = '',
  robots = 'index, follow',
  canonicalUrl = '',
  mobileUrl = '',
  isCzech = false,

  links = [],
  customMeta = [],
  mobileQueryObj = {},

  isNotFoundPage = false,
  shouldAppendSearchBoxJSONLD = false,
  shouldAppendOrganizationJSONLD = false,
  renderHreflangs = true,
  renderCanonical = true,
  allowEmptyHreflangs = true,
  customTitleTemplate = false,
  renderMobileAlternate = true,
  originByLocaleMap,
  mobileOriginByLocaleMap,
  excludeLocales,
  hrefLangsRelatedToLocale,
  hasDroppedSubDomain,
}: IDocumentHead) {
  const meta = generateMeta({
    robots,
    description,
    defaultDescription,
    title,
    defaultTitle,
    customMeta,
    isCzech,
  })
  const titleTemplate = customTitleTemplate ? '%s' : '%s | ABOUT YOU'

  const headLinks = prepareLinks({
    links,
    renderHreflangs: robots.includes('noindex') ? false : renderHreflangs,
    renderMobileAlternate:
      hasDroppedSubDomain || robots.includes('noindex')
        ? false
        : renderMobileAlternate,
    renderCanonical: robots.includes('noindex') ? false : renderCanonical,
    isNotFoundPage,
    allowEmptyHreflangs,
    mobileQueryObj,
    currentPath,
    locale,
    currentUrl,
    canonicalUrl,
    mobileUrl,
    originByLocaleMap,
    mobileOriginByLocaleMap,
    excludeLocales,
    hrefLangsRelatedToLocale,
  })

  return (
    <Helmet
      encodeSpecialCharacters={false}
      defaultTitle={defaultTitle}
      titleTemplate={titleTemplate}
      title={unescape(title)}
      meta={meta}
      link={headLinks}
    >
      {shouldAppendSearchBoxJSONLD && (
        <script type="application/ld+json">{`
        {
          "@context": "http://schema.org",
          "@type": "WebSite",
          "url": "https://www.aboutyou.at",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://www.aboutyou.at/search?term={search_term_string}&search_source=organic-srp",
            "query-input": "required name=search_term_string"
          }
        }
        `}</script>
      )}

      {shouldAppendOrganizationJSONLD && (
        <script type="application/ld+json">{`
        {
          "@context" : "http://schema.org",
          "@type" : "Organization",
          "name" : "ABOUT YOU",
          "url" : "https://www.aboutyou.at",
          "logo": "https://www.modeexpertise.de/aylogo/logo.png",
            "contactPoint": [{
              "@type": "ContactPoint",
              "telephone": "+43-800-29-85-55",
              "contactType": "customer service",
              "contactOption": "TollFree",
              "areaServed": "AT"}]
        }
        `}</script>
      )}
    </Helmet>
  )
}

export default connect(DocumentHead)
